import React from 'react';
import propTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { LinkExternal } from 'cstar-react-primitives/lib/redux-form/LinkExternal';


export const AnchorToLink = ({ href, children }) => {
    const linkProps = {
        to: href
    };
    const externalLinkProps = {
        url: href
    };
    const linkText = children && children[0] ? children[0] : href;
    return (
        
        href.indexOf('/store') === 0
            ? <Link {...linkProps}>{linkText}</Link>
            : <LinkExternal {...externalLinkProps}>{linkText}</LinkExternal>
    );
};

AnchorToLink.propTypes = {
    href: propTypes.string.isRequired,
    children: propTypes.array.isRequired
};
